<template>
  <div class="w-100 d-flex flex-column mb-3" v-if="hints.length > 0">
    <information-item 
      v-for="(item, index) in uniquifyHints(hints)" 
      :key="`hint-${index}`"
      :type="item.type"
      :message-id="item.messageId"
      :fill-in-data="item.fillInData" />
  </div>
</template>

<script>
import InformationItem from './InformationItem'
import isEqual from 'lodash.isequal'
import uniqWith from 'lodash.uniqwith'

export default {
  props: {
    hints: {
      type: Array,
      default: () => []
    }
  },
  components: {
    InformationItem
  },
  methods: {
    uniquifyHints: (hints) => uniqWith(hints, isEqual)
  }
}
</script>